import { render, staticRenderFns } from "./FormEntrada.vue?vue&type=template&id=4c2af4ef"
import script from "./FormEntrada.vue?vue&type=script&lang=js"
export * from "./FormEntrada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports